import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-insight-table-modal',
  templateUrl: './insight-table-modal.component.html',
  styleUrls: ['./insight-table-modal.component.css']
})
export class InsightTableModalComponent implements OnInit {

  @Input() TableData: any;
  @Input() title: any;
  typeOfTable = 'custom-table'
  shortingConf :any ={Test_Name:false,Current_Attempt:false,Start_Time:false,marksObtained:false}
  counts: number;
  selectedField: any;
  originalTableData: any[]=[];
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.originalTableData = JSON.parse(JSON.stringify(this.TableData));

 }


  checkEvenOdd(number) {
    if (number % 2 === 0) {
      return true;
    } else {
      return false;
    }
  }

  filter_by_colum(item:any){

    if(this.selectedField ==  item){
      this.counts++
     }else{
      this.counts=0;
     }
     let checAssending = ((this.counts % 2) == 0);
     let field=item;

     for (const key in this.shortingConf) {

         if(key == item){
           this.shortingConf[key] = !this.shortingConf[item]
         }else{
           this.shortingConf[key] = false
         }
     }
     this.selectedField = item;

     if(checAssending){
      this.TableData = this.originalTableData.sort((a, b) => (a[field] || "").toString().localeCompare((b[field] || "").toString())).reverse()
      // console.log(filter_data);
      // this.setPage(1)
     }else{
      this.TableData = this.originalTableData.sort((a, b) => (a[field] || "").toString().localeCompare((b[field] || "").toString()))
      // console.log(filter_data);
      // this.setPage(1)
     }

  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-modal-module/insight-table-modal/insight-table-modal.component.ts